<template>
    <div v-if="config_estate" v-cloak class="estate-images" :class="'estate-images-v' + config_estate.media_template">
        <!-- <div class="estate-badge star-color">
            <span v-if='estate.top' class="star"><masked-image src="/img/icons/ico_star.svg" /></span>{{ trans('labels.property_top') }}
        </div> -->
        <div v-if="$root.is_mobile" class="mobile-carousel">
            <estate-actions :estate="estate" />
            <my-carousel :per-page="1">
                <slide v-for="image in estate.media.images" :key="image.id">
                    <lazy-image :image="image.url.gallery_media" />
                </slide>
            </my-carousel>

            <media-gallery-opener :estate="estate" />
        </div>

        <div v-else-if="config_estate.media_template == 2" class="desktop-mosaic p-03">
            <div class="row">
                <div class="col-8 cursor-pointer pr-0" @click="openMediaGallery(0)">
                    <lazy-image
                        :image="estate.media.images[0] ? estate.media.images[0].url.detail : ''"
                        additional-class="main-image"
                        width="810"
                        height="655"
                    />
                    <media-gallery-opener :estate="estate" container-class="media-buttons" />
                </div>

                <div class="col-4">
                    <div class="row">
                        <div
                            v-if="estate.media.images.length > 4"
                            class="image_count"
                            @click="openMediaGallery(3)"
                        >
                            <img src="/img/icons/ico_photo.svg" />
                            <span>+{{ estate.media.images.length - 4 }}</span>
                        </div>
                        <div
                            v-for="i in range(1, 4)"
                            :key="i"
                            class="col-12 cursor-pointer"
                            @click="openMediaGallery(i)"
                        >
                            <lazy-image
                                :image="estate.media.images[i] ? estate.media.images[i].url.gallery_media : ''"
                                width="288"
                                height="216"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="config_estate.media_template == 1" class="desktop-mosaic">
            <div class="row">
                <div class="col-7 cursor-pointer" @click="openMediaGallery(0)">
                    <lazy-image
                        :image="estate.media.images[0] ? estate.media.images[0].url.detail : ''"
                        additional-class="main-image"
                        width="810"
                        height="500"
                    />
                </div>

                <div class="col-5">
                    <div class="row">
                        <div v-for="i in range(1, 5)" :key="i" class="col-6 cursor-pointer" @click="openMediaGallery(i)">
                            <lazy-image
                                :image="estate.media.images[i] ? estate.media.images[i].url.gallery_media : ''"
                                width="288"
                                height="216"
                            />
                        </div>
                    </div>
                    <media-gallery-opener :estate="estate" container-class="media-buttons" />
                </div>
            </div>
        </div>

        <modal-media-gallery />
    </div>
</template>

<script>
import { range } from 'lodash'

import LazyImage from './LazyImage'
import MediaButtons from './MediaButtons'
import MediaGalleryOpener from './MediaGalleryOpener'
import ModalMediaGallery from './ModalMediaGallery'
import MyCarousel from '../MyCarousel'
import UserActions from './UserActions'

export default {
    components: {
        'estate-actions': UserActions,
        'lazy-image': LazyImage,
        'media-buttons': MediaButtons,
        'media-gallery-opener': MediaGalleryOpener,
        'modal-media-gallery': ModalMediaGallery,
        'my-carousel': MyCarousel,
    },

    props: {
        config_estate: {
            type: Object,
            required: true,
        },
        
        estate: {
            type: Object,
            required: true,
        },
    },

    methods: {
        range(start, end) {
            return range(start, end)
        },

        openMediaGallery(index){
            window.events.$emit('showModal', {
                name: 'media-gallery',
                data:{
                    estate: this.estate,
                    first_active: 'images',
                    active_image: index,
                    buttons: true
                },
            })
        }
    },
    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },    
}
</script>